import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsCarousel } from './components/TestimonialsCarousel';
import { ProblemSection } from './components/ProblemSection';
import { ProductOverview } from './components/ProductOverview';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { GestionProfesional } from './components/GestionProfesional';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '2178960392907335');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-charcoal selection:bg-gold/30" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2178960392907335&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Navbar data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <TestimonialsCarousel data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <ProductOverview data-id="element-8" />
        <BonusSection data-id="element-9" />

        <section className="py-20 bg-beige/30 pt-[39px] pb-[39px]" data-id="element-10">
          <CountdownTimer data-id="element-11" />
          <PricingSection data-id="element-12" />
        </section>

        <GestionProfesional data-id="element-13" />
        <ExtendedTestimonials data-id="element-14" />
        <Guarantee data-id="element-15" />
        <FAQ data-id="element-16" />
        <CostComparison data-id="element-17" />
        <FinalCTA data-id="element-18" />
      </main>
      <Footer data-id="element-19" />
      <PurchaseNotification data-id="element-20" />
    </div>;
}